export class ReferralTrackingHandler {
  constructor() {
    this.initialized = true;
  }

  trackReferral(referralData) {
    if (!referralData) return;
    
    // Log referral data in development
    if (process.env.NODE_ENV !== 'production') {
      console.log('Tracking referral data:', referralData);
    }

    // Send to Google Tag Manager if available
    if (window.dataLayer) {
      const dataLayerEvent = {
        event: 'referral_tracked',
        referral_status: referralData.status || 'registered'
      };
      
      // Add all tracking parameters to the event
      Object.entries(referralData).forEach(([key, value]) => {
        dataLayerEvent[`referral_${key}`] = value;
      });
      
      window.dataLayer.push(dataLayerEvent);
    }

    // Send to Facebook Pixel if available
    if (window.fbq) {
      window.fbq('track', 'ReferralTracked', referralData);
    }
  }
} 